import { RootState } from "../store/store";

export const forecastDistributionResource = (state: RootState) =>
  state.distributions.forecastDistributionsResource
    .forecastDistributionsResource;

export const forecastDistributionResourceFromGraph = (state: RootState) =>
  state.distributions.forecastDistributionsResourceFromGraph
    .forecastDistributionsResource;
